import { FC } from 'react';

import { classnames } from '@/shared/utils/classnames';

import BlueLogo from '@/assets/icons/brand-blue.svg?react';
import Logo from '@/assets/icons/brand.svg?react';
import { WithClassName } from '@/shared/types/global/common.types.ts';

type Props = WithClassName & {
  color?: 'blue' | 'white';
};

export const SiteLogo: FC<Props> = ({ className, color }) => {
  if (color === 'blue')
    return (
      <BlueLogo
        className={classnames('h-[33px] w-[140px] fill-white text-transparent', className)}
      />
    );

  return <Logo className={classnames(className)} />;
};
